// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

a {
  display: block;
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
  padding: 0px;
}

*:focus {
  outline: none !important;
}

*:active {
  outline: none !important;
}

/*========================================
       Color Variable Start Here
=========================================*/

html{
  --primary-color: #DA1A32;
  --primary-light: #da1a3011;
  --primary-light2: #da1a3033;
  --black-color: #000000;
  --gray-opacity-50: rgb(102,102,102);
  --gray-opacity-80: rgb(162, 162, 162);
  --black-opacity-60: rgba(0, 0, 0, 0.6);
  --black-opacity-40: rgba(0, 0, 0, 0.4);
  --white-color: #ffffff;
  --dark-text-color: #1f2327;
  --steps-background: #F5F8FB;
  --steps-border-color: #DDE1EB;
  --desc-color: #4D4F59;
  --desc-color2: #6C6F7C;
  --info-button-bg: #edf1f7;
  --blue-input-border: rgb(80,147,207);
  --problem-card-border-color: #d3d7e1;
  --date-radio-bg: #F2F0FA;
  --radio-border-color: #616064;
  --problem-button-bg: #F8FBFD;
  --description-button-hover: #EBEBEF;
}

/*========================================
       Color Variable End Here
=========================================*/`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;0CAE0C;;AAE1C;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,mCAAmC;EACnC,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;EACtC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;;0CAE0C","sourcesContent":["html {\n  box-sizing: border-box;\n}\n\nbody {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: 'Poppins', sans-serif;\n}\n\nul,\nli {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\na {\n  display: block;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0px;\n  padding: 0px;\n}\n\n*:focus {\n  outline: none !important;\n}\n\n*:active {\n  outline: none !important;\n}\n\n/*========================================\n       Color Variable Start Here\n=========================================*/\n\nhtml{\n  --primary-color: #DA1A32;\n  --primary-light: #da1a3011;\n  --primary-light2: #da1a3033;\n  --black-color: #000000;\n  --gray-opacity-50: rgb(102,102,102);\n  --gray-opacity-80: rgb(162, 162, 162);\n  --black-opacity-60: rgba(0, 0, 0, 0.6);\n  --black-opacity-40: rgba(0, 0, 0, 0.4);\n  --white-color: #ffffff;\n  --dark-text-color: #1f2327;\n  --steps-background: #F5F8FB;\n  --steps-border-color: #DDE1EB;\n  --desc-color: #4D4F59;\n  --desc-color2: #6C6F7C;\n  --info-button-bg: #edf1f7;\n  --blue-input-border: rgb(80,147,207);\n  --problem-card-border-color: #d3d7e1;\n  --date-radio-bg: #F2F0FA;\n  --radio-border-color: #616064;\n  --problem-button-bg: #F8FBFD;\n  --description-button-hover: #EBEBEF;\n}\n\n/*========================================\n       Color Variable End Here\n=========================================*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
